import { useEffect, useState } from 'react';
import { useNavigate } from '@usas/ui-web/wrappers/ReactRouterDom';

import NavLinks from '../../views/meet/NavLinks';
import MyMeetsNavLinks from '../../views/myMeets/MyMeetsNavLinks';
import OrgUnitAdminUserViews from '../../views/entry/orgUnitAdminUser/OrgUnitAdminUserViews';
import { getViewData } from '../../views/entry/orgUnitAdminUser/OrgUnitAdminUserViews';

import useOmeMeetData from '../../state/omeMeet/UseOmeMeetData';
import useOmeMeetOrgUnitEntryInfoData from '../../state/omeMeetOrgUnitEntryInfo/UseOmeMeetOrgUnitEntryInfoData';
import useOUAdminEntryContextData from '../../state/ouAdminEntryContextView/UseOUAdminEntryContextData';
import useMyMeetsFiltersData from '../../state/myMeetsFilters/UseMyMeetsFiltersData';

import useSearchMeetData from '@usas/ui-web/state/searchMeet/UseSearchMeetData';
import useSelectOrgUnitData from '@usas/ui-web/state/selectOrgUnit/UseSelectOrgUnitData';

const INITIAL_STATE = {
  name: '',
  subHeaderText: '',
  instructionText: '',
  nextButtonText: '',
  backButtonText: '',
  saveAndExitButtonText: ''
};

const useViewTemplate = (viewName, onBackButtonClicked) => {
  const navigate = useNavigate();
  const { omeMeetState } = useOmeMeetData();
  const { omeMeetOrgUnitEntryInfoState } = useOmeMeetOrgUnitEntryInfoData();
  const { oUAdminEntryContextState } = useOUAdminEntryContextData();
  const { searchMeetState, setSearchMeetState } = useSearchMeetData();
  const { selectOrgUnitState } = useSelectOrgUnitData();
  const { myMeetsFiltersState } = useMyMeetsFiltersData();
  const [view, setView] = useState(INITIAL_STATE);

  const handleMeetRouteSaveAndExit = () => {
    setSearchMeetState({ ...searchMeetState, showMeetHeader: true });
    navigate(NavLinks.MEET_ENTRY_TEAM, { state: { tryGetOmeMeet: true } });
  }

  const handleBackButtonClicked = (e) => {
    if (onBackButtonClicked instanceof Function) {
      onBackButtonClicked(e);
    } else {
      if (e?.preventDefault) {
        e.preventDefault();
      }
      if (omeMeetState.route !== '') {
        handleMeetRouteSaveAndExit();
      }
      else {
        navigate(MyMeetsNavLinks.MEET_ENTRY_TEAM, { state: { selectOrgUnitState: selectOrgUnitState, myMeetsFiltersState: myMeetsFiltersState } });
      }
    }
  };

  useEffect(() => {
    const foundView = getViewData(viewName);
    if (foundView) {
      if (oUAdminEntryContextState.isReadOnly === true) {
        foundView.saveAndExitButtonText = 'Exit';
        if (foundView.name === OrgUnitAdminUserViews.OME_MEET_INFO_TEAM_ENTRY) {
          foundView.backButtonText = '';
        }
        if (foundView.name === OrgUnitAdminUserViews.OME_MEET_SUBMITTED) {
          foundView.nextButtonText = '';
        }
      }

      if (foundView.name === OrgUnitAdminUserViews.OME_MEET_ROSTER_ENTRIES) {
        foundView.instructionText = omeMeetOrgUnitEntryInfoState.objData?.allowRelayOnlySwimmer === true ? "Add at least one Athlete to the Roster. All Athletes on the Roster must have a Status of 'Events Approved' or 'Relay Only Swimmer'." :
          omeMeetOrgUnitEntryInfoState.objData?.allowRelayOnlySwimmer === false ? "Add at least one Athlete to the Roster. All Athletes on the Roster must have a Status of 'Events Approved' ('Relay Only Swimmer' status is not allowed)." :
            "Add at least one Athlete to the Roster. All Athletes on the Roster must have a Status of 'Events Approved' or 'Relay Only Swimmer' (if Relay Only Swimmers are Allowed).";
      }
      if (foundView.name === OrgUnitAdminUserViews.OME_MEET_CREDENTIALS) {
        foundView.instructionText = omeMeetOrgUnitEntryInfoState.objData?.maxCredentialNumber !== undefined && omeMeetOrgUnitEntryInfoState.objData?.maxCredentialNumber !== null && omeMeetOrgUnitEntryInfoState.objData?.maxCredentialNumber >= 0 ? `Add or Remove Credentials. The Number of Allowed Credentials is Determined by the Meet's Deck Pass Rules. With the Current Roster, ${omeMeetOrgUnitEntryInfoState.objData?.maxCredentialNumber ?? ''} Credential${omeMeetOrgUnitEntryInfoState.objData?.maxCredentialNumber === 1 ? ' is' : 's are'} Allowed. ${omeMeetOrgUnitEntryInfoState.objData?.credentialsCanBeAddedAfterCap === true ? 'Only Massage Credentials can be Added after the Cap has been Reached.' : 'No Credentials can be Added after the Cap has been Reached.'}` :
          "Add or Remove Credentials. The Number of Allowed Credentials is Determined by the Meet's Deck Pass Rules.";
      }
      if (foundView.name === OrgUnitAdminUserViews.OME_MEET_SUBMIT || foundView.name === OrgUnitAdminUserViews.OME_MEET_SUBMIT) {
        if (omeMeetOrgUnitEntryInfoState.objData.teamOrgUnitName === 'Unattached') {
          foundView.instructionText = 'Unattached teams cannot make purchases. Individual unattached athletes will complete their own purchases through the Athlete Entry process.';
        }
        else {
          foundView.instructionText = 'Make Purchases and Submit the Team Entry.';
        }
      }
      setView({ ...foundView });
    }
  }, [viewName, oUAdminEntryContextState.isReadOnly, omeMeetOrgUnitEntryInfoState]);

  return {
    ...view,
    handleBackButtonClicked,
    omeMeetOrgUnitEntryInfoState
  };
};

export default useViewTemplate;
